import { Analytics } from './analytics';
import { ItemAction } from '../../../item/actions/item_action';

export class CartAddTogether extends Analytics {
  constructor() {
    super();
    ItemAction.CART_ADD_TOGETHER_EVENT.on((data) => {
      this.run(() => {
        const items: any = [];
        const products: any = [];
        const productsForSoloel: any = [];
        data.analyticsData.items.forEach((item: any) => {
          items.push(this.items(item.getProductName(), item.getMedicalMaterialType()));
          products.push(this.products(item._catalogItemCode, item.getMedicalMaterialType()));
          productsForSoloel.push(this.products(item.getProductNameForSoloel(), item.getMedicalMaterialType()));
        });
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: '一緒にかご投入完了',
          events: ['scAdd', 'event113'],
          items: items,
          club: {
            server: 'club/pc',
            prop5: '一緒にかご投入完了',
            events: ['scAdd', 'event113'],
            products: products
          },
          soloel: {
            server: 'soloel/pc',
            prop5: '一緒にかご投入完了',
            events: ['scAdd', 'event96'],
            products: productsForSoloel
          }
        };

        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
      });
    });
  }

  private items(productName: string, evars: string) {
    return {
      category: '',
      productName: productName,
      quantity: '',
      price: '',
      events: [],
      evars: this.medicalMaterialType(evars)
    };
  }

  private products(productName: string, evars: string) {
    return {
      category: '',
      productName: productName,
      quantity: '',
      price: '',
      events: [],
      evars: this.eVar79(evars)
    };
  }

  private medicalMaterialType(evars: string) {
    return { medicalMaterialType: evars };
  }

  private eVar79(evars: string) {
    return { eVar79: evars };
  }
}
